import {IamAuthGrantConfig} from '@msi/commandcentral-common-header';
import { providePrimeNGConfig } from '@msi/cobalt-prime';
import { ApplicationConfig } from '@angular/core';

const CLIENT_ID = 'CQAdmin';
const SCOPES = ['CCAdmin'];

export function getAppSpecificIamConfig(): IamAuthGrantConfig {
  const config: IamAuthGrantConfig = {
    scopes: SCOPES,
    clientId: CLIENT_ID,
    developmentMode: false,
    singlePreprod: true
  };
  return config;
}

export const appConfig: ApplicationConfig = {
  providers: [
    providePrimeNGConfig({
      prefix: 'msi',
      darkModeSelector: '.dark',
      cssLayer: {
        name: 'primeng',
        order: 'reset primeng',
      },
    }),
  ],
};
